import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=24e8e8ed&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=js&"
export * from "./Security.vue?vue&type=script&lang=js&"
import style0 from "./Security.vue?vue&type=style&index=0&id=24e8e8ed&lang=scss&scoped=true&"
import style1 from "./Security.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e8e8ed",
  null
  
)

export default component.exports